import Layout from '@/components/Layout/Layout'
import NotFound from '@/components/NotFound/NotFound'
import PermissionDenied from '@/components/PermissionDenied/PermissionDenied'
import ProtectedRoute from '@/routes/ProtectedRoute'
import { isAuthTokenValid } from '@/utils'
import { Navigate, Route, Routes } from 'react-router'
import { PROTECTED_ROUTES, PUBLIC_ROUTES } from './AppNavigationRoutes'

const Router = () => {
    const RedirectIfAuthenticated = ({ children }) => {
        return isAuthTokenValid() ? <Navigate to={'/app/dashboard'} replace /> : children;
    };

    return (
        <Routes>
            <Route path={'/'} element={<Navigate to={isAuthTokenValid() ? '/app/dashboard' : '/auth/login'} replace />} />

            {/* public routes */}
            {PUBLIC_ROUTES.map(({ key, path, Component }) => (
                <Route
                    key={key}
                    path={path}
                    element={key === 'login' ? (
                        <RedirectIfAuthenticated>
                            <Component />
                        </RedirectIfAuthenticated>
                    ) : (
                        <Component />
                    )}
                />
            ))}

            {/* permission denied */}
            <Route path={'/permission-denied'} element={<PermissionDenied />} />

            {/* layout */}
            <Route element={<Layout />}>
                {/* protected routes */}
                {PROTECTED_ROUTES.map(({ key, path, Component, featureKey }) => (
                    <Route
                        key={key}
                        path={path}
                        element={
                            <ProtectedRoute featureKey={featureKey}>
                                <Component />
                            </ProtectedRoute>
                        }
                    />
                ))}
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default Router;
